import React from "react";
import {
	BsCheckCircle,
	BsCloudUpload,
	BsDownload,
	BsFileEarmarkExcel,
} from "react-icons/bs";

const STEPS = [
	{
		id: 1,
		label: "Get list",
		short: "Get",
		Icon: BsDownload,
	},
	{
		id: 2,
		label: "Send list",
		short: "Send",
		Icon: BsFileEarmarkExcel,
	},
	{
		id: 3,
		label: "Add files",
		short: "Files",
		Icon: BsCloudUpload,
	},
	{
		id: 4,
		label: "Done",
		short: "Done",
		Icon: BsCheckCircle,
	},
];

/**
 * Visual progress for the bulk attach workflow.
 * @param {number} current - 1..4
 */
const WizardStepper = ({ current = 1 }) => {
	return (
		<nav aria-label="Bulk upload progress" className="w-full">
			<ol className="flex items-start justify-between gap-1">
				{STEPS.map((step, index) => {
					const done = current > step.id;
					const active = current === step.id;
					const upcoming = current < step.id;
					const Icon = step.Icon;

					return (
						<li
							key={step.id}
							className="relative flex flex-1 flex-col items-center text-center"
						>
							{index > 0 ? (
								<span
									aria-hidden="true"
									className={`absolute left-0 top-4 -z-0 h-0.5 w-full transition-colors duration-300 ${
										done || active ? "bg-akgreen" : "bg-gray-200"
									}`}
									style={{ width: "100%", left: "-50%" }}
								/>
							) : null}
							<span
								className={`relative z-10 flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold transition-all duration-300 ${
									done
										? "bg-akgreen text-white shadow-sm"
										: active
										? "bg-akgreen text-white shadow-md ring-2 ring-akgreen/20"
										: "bg-gray-100 text-gray-500"
								}`}
								aria-current={active ? "step" : undefined}
							>
								{done ? (
									<BsCheckCircle className="h-4 w-4" aria-hidden />
								) : (
									<Icon className="h-3.5 w-3.5" aria-hidden />
								)}
							</span>
							<span
								className={`mt-1.5 hidden text-xs font-semibold sm:block ${
									active
										? "text-akgreenest"
										: upcoming
										? "text-gray-400"
										: "text-gray-700"
								}`}
							>
								{step.label}
							</span>
							<span
								className={`mt-1 text-xs sm:hidden ${
									active
										? "font-semibold text-akgreenest"
										: "text-gray-500"
								}`}
							>
								{step.short}
							</span>
						</li>
					);
				})}
			</ol>
		</nav>
	);
};

export default WizardStepper;
